import styled, { css } from 'styled-components';
import { MEDIA_QUERY_DEVICE, GAP_MAP, GUTTER_MAP } from '../constants/media-queries';
import { SCREEN_SIZE, GRID_COLUMNS, DEVICE_TYPE } from '../constants/sizes';
const mediaQueryRow = (type) => css `
    @media ${MEDIA_QUERY_DEVICE[type]} {
        padding: 0 ${GAP_MAP[type]};

        display: grid;
        grid-gap: ${GUTTER_MAP[type]};
        grid-auto-rows: min-content;
        grid-template-columns: repeat(${GRID_COLUMNS[type]}, 1fr);

        min-width: ${SCREEN_SIZE[type].min};
        max-width: ${SCREEN_SIZE[type].max};
    }
`;
const ResponsiveRowStyles = css `
    ${mediaQueryRow(DEVICE_TYPE.MOBILE)}
    ${mediaQueryRow(DEVICE_TYPE.TABLET)}
    ${mediaQueryRow(DEVICE_TYPE.DESKTOP)}
    ${mediaQueryRow(DEVICE_TYPE.DESKTOP_HD)}
`;
export const Row = styled.div `
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    width: ${({ width }) => width ? width : '100%'};
    height: ${({ height }) => height ? height : '100%'};

    ${({ top }) => top && `top: ${top}`};
    position: ${({ positionFixed }) => positionFixed ? 'fixed' : 'relative'};

    ${ResponsiveRowStyles}
`;
//# sourceMappingURL=Row.styled.js.map